import AdminAuctionsList from "./AdminAuctionsList";
export default AdminAuctionsList;
